import { isDarkColor } from "@omni/utils/color.helper";
import { cn } from "@omni/utils/styles";

import { usePaintConfiguratorContext } from "@/components/PaintConfigurator/context/paintConfigurator.context";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { useProductsContext } from "../../context/products.context";
import { PreviewElement } from "./components/previewElement";

const Preview = () => {
    const { t } = useGranite();
    const {
        state: { colorHex, colorName, colorId }
    } = usePaintConfiguratorContext();

    const { selectedFinish, selectedVolume } = useProductsContext();

    if (!colorId || !colorHex || !colorName) return null;

    return (
        <div
            className={cn(
                "tw:rounded-sm tw:relative tw:border tw:border-grey-light",
                "tw:lg:overflow-hidden tw:lg:aspect-square"
            )}
            style={{ backgroundColor: `#${colorHex.replaceAll("#", "")}` }}
        >
            <div
                className={cn("tw:w-full", {
                    "tw:text-background": isDarkColor(colorHex),
                    "tw:text-foreground": !isDarkColor(colorHex)
                })}
            >
                <div
                    className={cn(
                        "tw:flex tw:flex-row-reverse tw:justify-end",
                        "tw:lg:flex-col tw:lg:justify-start"
                    )}
                >
                    {selectedVolume && (
                        <PreviewElement
                            label={t("paintConfigurator.volume.label")}
                            value={selectedVolume.volume.value.toUpperCase()}
                            animate={true}
                        />
                    )}
                    {selectedFinish && (
                        <PreviewElement
                            label={t("paintConfigurator.finish.label")}
                            value={selectedFinish.value}
                            animate={true}
                        />
                    )}
                    {colorName && (
                        <PreviewElement
                            label={t("paintConfigurator.color.label")}
                            value={colorName}
                            animate={false}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export { Preview };
